import { render, staticRenderFns } from "./SaleHistoryEvent.vue?vue&type=template&id=86dcf5c0&scoped=true"
import script from "./SaleHistoryEvent.vue?vue&type=script&lang=ts"
export * from "./SaleHistoryEvent.vue?vue&type=script&lang=ts"
import style0 from "./SaleHistoryEvent.vue?vue&type=style&index=0&id=86dcf5c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dcf5c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86dcf5c0')) {
      api.createRecord('86dcf5c0', component.options)
    } else {
      api.reload('86dcf5c0', component.options)
    }
    module.hot.accept("./SaleHistoryEvent.vue?vue&type=template&id=86dcf5c0&scoped=true", function () {
      api.rerender('86dcf5c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleHistoryEvent.vue"
export default component.exports